import { selectActivePackageTranslatedName } from '@va/aaas/shared/selectors';
import { NextResetDate3AS } from '@va/dashboard/shared/feature-counter';
import { LightningIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { fontWeights, Paragraph, paragraphSizes } from '@va/ui/design-system';
import { useSelector } from 'react-redux';

type CurrentPlanProps = {
  label?: string;
};

export const CurrentPlan = ({ label }: CurrentPlanProps) => {
  const translate = useTranslate();
  const activePackageName = useSelector(selectActivePackageTranslatedName(translate));

  return (
    <div className='flex flex-row gap-2 rounded-15'>
      <div className='flex items-center justify-center rounded-12 bg-black-dark/50 p-15px'>
        <LightningIcon className='shrink-0' color='#FFFF' />
      </div>
      <div className='flex flex-col'>
        <div className='flex flex-row xs:flex-col'>
          <Paragraph size={paragraphSizes.large} weight={fontWeights.semibold} colorClassName='text-white'>
            {label ?? translate('featureCounter.currentPlan')}
          </Paragraph>
          <Paragraph className='ml-2' size={paragraphSizes.large} weight={fontWeights.semibold}>
            <span>{activePackageName}</span>
          </Paragraph>
        </div>
        <NextResetDate3AS />
      </div>
    </div>
  );
};
